import Tab, { type TabProps } from '@mui/material/Tab';

import type { DaaSType } from '../../types';
import { DAAS_TYPE_TABS } from '../DaaSExplorer/typeTabs';
import { useStyles } from './styles';

export type DaaSTypeTabProps = Omit<TabProps, 'value' | 'label'> & {
  value: DaaSType;
  count?: number;
  size?: 'medium' | 'small';
};

/** A tab for one DaaS type: its icon, its label and, once known, its count. */
export const DaaSTypeTab = ({
  value,
  count,
  size = 'medium',
  className,
  ...tabProps
}: DaaSTypeTabProps) => {
  const { classes, cx } = useStyles();
  const tab = DAAS_TYPE_TABS.find(({ type }) => type === value);
  if (!tab) return null;
  const { label, Icon } = tab;
  const small = size === 'small';

  return (
    <Tab
      {...tabProps}
      value={value}
      aria-label={count === undefined ? label : `${label} (${count})`}
      className={cx(classes.typeTab, small && classes.smallTypeTab, className)}
      label={
        <span
          className={cx(classes.typeTabName, small && classes.smallTypeTabName)}
        >
          <Icon size={size} alt="" />
          <span>{label}</span>
          {count !== undefined && <span>{count}</span>}
        </span>
      }
    />
  );
};
